import { render, staticRenderFns } from "./Promocoes.vue?vue&type=template&id=46cd0b8a&scoped=true&"
import script from "./Promocoes.vue?vue&type=script&lang=js&"
export * from "./Promocoes.vue?vue&type=script&lang=js&"
import style0 from "./Promocoes.vue?vue&type=style&index=0&id=46cd0b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd0b8a",
  null
  
)

export default component.exports